import { useQuery } from '@tanstack/react-query';
import { type SupportedLocaleMap } from '@zep-us/i18n';

import { getZepetofulCDNContent } from '@/api/zepetoful.api';

type PricingContent = {
  questions: {
    question: SupportedLocaleMap<'ko' | 'en' | 'ja'>;
    answer: SupportedLocaleMap<'ko' | 'en' | 'ja'>[];
  }[];
};

const ZEPETOFUL_PRICING_CONTENT_ID = 'oEFlK3wK87dunhp3OEGBPXS';

export const usePricingContent = () => {
  const { data } = useQuery({
    queryKey: ['pricing-content', ZEPETOFUL_PRICING_CONTENT_ID],
    queryFn: () =>
      getZepetofulCDNContent<PricingContent>({
        entryId: ZEPETOFUL_PRICING_CONTENT_ID,
      }),
    staleTime: 10 * 60 * 1000, // 10 minutes cache for pricing content
  });

  return {
    data,
  };
};
